<template>
  <div>
    <loading-state :state="state"></loading-state>
    <div class="match cricket mini" v-if="forMatch.key" ref="matchroot">
      <div class="list-title">
        <router-link
          class="clean"
          :to="{ name: isMetric ? 'MetricCricketMatch' : 'cricketMatch', params:{key:forMatch.key}}"
          >
          <span v-if="useShortTitle">{{forMatch.related_name}} - {{forMatch.short_name}}</span>
          <span v-else>{{forMatch.teams.a.name}} - {{forMatch.teams.b.name}} {{forMatch.related_name}}</span>
          </router-link>
        <span class="live-tag" :class="{'live-now': forMatch.isLiveNow}" v-if="forMatch.status.isStarted">{{forMatch.liveStatusText}}</span>
      </div>
      <div v-if="forMatch.msgs.info">
        <span class="highlight">{{forMatch.msgs.info}}</span>
      </div>
      <div>
        <span v-if="showDate">{{forMatch.start_at | relativeShortDate}} </span>
        <span class="info" v-if="forMatch.day > 1 && !showDate">Previous Day </span>
        <span v-if="forMatch.format.isTest">
          <span class="info">{{forMatch.slotTime | relativeTime}} </span>
        </span>
        <span v-else>
          <span class="info">{{forMatch.start_at | relativeTime}}</span>
        </span>
        <span class="silent" v-if="forMatch.approxCompletedTime"> -
          <span v-if="showDate || (forDate && forDate.diff(forMatch.approxCompletedTime, 'days') != 0)">
            {{forMatch.approxCompletedTime | relativeShortDateTime}}
          </span>
          <span v-else>{{forMatch.approxCompletedTime | relativeTime}}</span>
        </span>
        <span v-if="forMatch.format.isTest">
          <span v-if="forMatch.day > 0"> (Day {{forMatch.day}})</span>
        </span>
      </div>
      <div><span class="sport-tag" v-if="showSport">C</span>{{forMatch.format.key}}<span v-if="showSeason"> -
        <router-link class="clean" :to="{name:'cricketSeason', params: {key: forMatch.season.key}}">
          {{forMatch.season.name}}
        </router-link>
      </span></div>
    </div>

  </div>
</template>
<style lang="scss" scoped>
</style>

<script>
import { CricketFirebase } from '@/models/firebase'
import { CricketMatch } from '@/models/cricket/match'
import { DataState } from '@/state'

export default {
  props: {
    match: {
      type: Object,
      default: null
    },
    matchKey: {
      type: String
    },
    forDate: {
      type: Object,
      default: null
    },
    showDate: {
      type: Boolean,
      default: true
    },
    showSport: {
      type: Boolean,
      default: false
    },
    showSeason: {
      type: Boolean,
      default: true
    },
    useShortTitle: {
      type: Boolean,
      default: false
    },
    isMetric : {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      state: DataState.newLoading(),
      minuteLabel: '',
      pushId: null,
      pushInited: false,
      forMatch: new CricketMatch()
    }
  },
  mounted () {
    if (this.match !== null) {
      this.forMatch = this.match
    }

    if (this.matchKey) {
      CricketMatch.fetch(this.matchKey, null, this.isMetric).then(updatedMatch => {
        this.forMatch.overwrite(updatedMatch)
        this.state.changeToLoaded()
        this.listenMatchUpdate()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    } else {
      this.listenMatchUpdate()
      this.state.changeToLoaded()
    }
  },
  destroyed () {
    if (this.pushId) {
      CricketFirebase.instance().stopMatchUpdate(this.matchKey, this.pushId)
      this.pushId = null
      this.pushInited = false
    }
  },
  methods: {
    onMatchUpdated (match) {
      // this.match = match
    },

    listenMatchUpdate () {
      if (this.match && this.forMatch.requiresLiveUpdate && (!this.pushInited)) {
        this.pushId = CricketFirebase.instance().listenMatch(this.forMatch.key, (updatedMatch) => {
          this.forMatch.overwrite(updatedMatch)
          this.onMatchUpdated(this.match)
        })
        this.pushInited = true
      }
    }
  }
}
</script>
